<template>
	<div class=" header d-flex align-items-center" style="">
		<div class="title">
			<span class="text-capitalize">{{$t($route.meta.i18nTranslate)}}</span>
			<nav aria-label="breadcrumb">
				<ol class="breadcrumb">
					<li class="item1 p-0"><router-link class="link" :to="{name: 'home'}">{{ $t('home') }} </router-link></li>
					<li class="item p-0" ><router-link class="link" :to="{name:$route.meta.i18nTranslate }">{{ $t($route.meta.i18nTranslate) }}</router-link></li>
					<li class="item p-0" v-if="path2" >
						<router-link v-if="path3" class="link" :to="{name:'categories-view', params:{slug : $route.params.categorySlug} }">
							{{ path2}}
						</router-link>
						<p v-else>
							{{ path2 }}
						</p>
						
					</li>
					<li class="item p-0" v-if="path3">
						<p class="m-0">
							{{ path3}}
						</p>
					</li>
				</ol>
			</nav>
		</div>
	</div>
</template>
<script>
export default {
	props: [
		'path1',
		'path2',
		'path3',
		'path2Slug',
		'path3Url'
	],
	computed: {
		getRout() {
			return 1;
		}
	},
	created() {

	},
	methods: {

	}
}
</script>
<style></style>